const ZertoHighlightCard = ({ badge, image, title, description }) => {
  return (
    <div className="flex flex-col items-start self-stretch gap-3 md:gap-4 md:w-[1128px]">
      {/**Upper */}
      <div className="flex flex-col items-start gap-3 md:gap-4 self-stretch">
        <div className="flex py-0.5 px-2.5 md:px-3 justify-center items-center gap-2.5 rounded-xl bg-navy-blue-03 text-white text-[10px] leading-[20px] md:text-[12px] md:leading-[22px] font-medium">
          <span className="text-[12px] font-google">{badge}</span>
        </div>
        <div
          className="
          w-full md:max-w-none md:w-full
          h-[128px] md:h-[400px]
          rounded-lg border border-black/10
          bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${image})`,
          }}
        />
      </div>
    </div>
  );
};
export default ZertoHighlightCard;
